import { render } from "./CopyText.vue?vue&type=template&id=2c0b6c21&scoped=true"
import script from "./CopyText.vue?vue&type=script&lang=js"
export * from "./CopyText.vue?vue&type=script&lang=js"

import "./CopyText.vue?vue&type=style&index=0&id=2c0b6c21&lang=scss&scoped=true"

import exportComponent from "/var/www/dmp/releases/1776447368/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c0b6c21"]])

export default __exports__